
import axios from "axios";

console.log("prooces->", process.env)


let url = process.env.REACT_APP_USER_MANAGEMENT_API_URL
// window.location.href.includes('local') || window.location.href.includes('dev') ?
//   'https://usermanagement-backend-dev-ca.proudground-2e220f19.westus2.azurecontainerapps.io/api/v1/' :
//   'https://usermanagement-backend-prod-ca.ambitiousisland-e0437822.westus2.azurecontainerapps.io/api/v1/'



export const client = axios.create({
  baseURL: url
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);



    let priceBookurl =  process.env.REACT_APP_PRICEBOOK_API_URL
  //   window.location.href.includes('dev') || window.location.href.includes('local')  ?
  // 'https://pricebook-backend-dev-ca.yellowcoast-fb3ac700.westus2.azurecontainerapps.io/api/v1/pricebook/'
  // : 'https://pricebook-backend-prod-ca.agreeablebay-76c1f56f.westus2.azurecontainerapps.io/api/v1/pricebook/'
   

export const priceBookclient = axios.create({
  baseURL: priceBookurl
});

priceBookclient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);



